import { ClassSwiperPeople } from "./modules/ClassSwiperPeople.js";

document.addEventListener("DOMContentLoaded", function () {

  /* ========== swiper ========== */
  const swiperPeopleElem = document.querySelector("#js-swiper-people");
  if (swiperPeopleElem) {
    const swiperPeople = new ClassSwiperPeople(swiperPeopleElem);

    const container = swiperPeopleElem.querySelector(".swiper-container");
    const FORCE_DELAY = 4000;

    const applyDelay = () => {
      const inst = container?.swiper;
      if (!inst?.params?.autoplay) return false;

      inst.params.autoplay.delay = FORCE_DELAY;

      inst.autoplay?.stop?.();
      inst.autoplay?.start?.();

      return true;
    };

    const timer = setInterval(() => {
      if (applyDelay()) clearInterval(timer);
    }, 50);
    setTimeout(() => clearInterval(timer), 3000);

    setTimeout(function () {
      swiperPeople.play();
    }, 400);
  }
});
